import caseConstants from "@/config/constants/caseConstants"
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
    }
  },
  async mounted() {
    // if (!this.skipFetchTestPanels) {
    //   await this.$store.dispatch("profile/fetchMyTestPanels", {
    //     include_test_details: true,
    //     get_all: true,
    //   })
    // }
  },
  computed: {
    ...mapGetters("profile", ["getTestPanelsData"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
  },
  methods: {
    caseTypesText(caseTypes) {
      return caseTypes
        .map((type) => this.caseTypeMap[type])
        .join(", ")
        .toUpperCase()
    },
    getFormattedValues(params) {
      for (let [key, value] in Object.entries(params)) {
        if (!value) {
          delete params[key]
        }
      }
      return params
    },
    getUserBasedCaseTypes(caseTypes = []) {
      if (
        Array.isArray(this.getAuthenticatedUser?.allowed_case_types) &&
        this.getAuthenticatedUser.allowed_case_types.length
      ) {
        const data = this.getAuthenticatedUser.allowed_case_types
        return caseTypes.filter((caseType) => data.includes(caseType.value))
      }
      return caseTypes
    },

    getLabBasedCaseTypes(caseTypes = []) {
      if (
        Array.isArray(this.getTestPanelsData) &&
        this.getTestPanelsData.length
      ) {
        const data = this.getTestPanelsData.map((e) => e.code)
        return caseTypes.filter((caseType) => data.includes(caseType.value))
      }

      return caseTypes
    },
  },
}
